import * as v from 'valibot';
import { coercedDate } from '../resources/index.js';
import { api } from './_base.js';
// Pricing tier mapping - matches PricingView.vue
export const PRICING_TIERS = {
    LITE: {
        name: 'Lite',
        students: 15,
        monthly: {
            lookupKey: 'lite_monthly',
            amount: 800, // $8.00 in cents
        },
        yearly: {
            lookupKey: 'lite_yearly',
            amount: 6000, // $60.00 in cents
        },
    },
    STANDARD: {
        name: 'Standard',
        students: 40,
        monthly: {
            lookupKey: 'standard_monthly',
            amount: 1300, // $13.00 in cents
        },
        yearly: {
            lookupKey: 'standard_yearly',
            amount: 9600, // $96.00 in cents
        },
    },
    PLUS: {
        name: 'Plus',
        students: 80,
        monthly: {
            lookupKey: 'plus_monthly',
            amount: 2200, // $22.00 in cents
        },
        yearly: {
            lookupKey: 'plus_yearly',
            amount: 16800, // $168.00 in cents
        },
    },
};
export const PricingTier = v.picklist(Object.keys(PRICING_TIERS));
export const SubscriptionStatus = v.picklist([
    'active',
    'canceled',
    'incomplete',
    'incomplete_expired',
    'past_due',
    'trialing',
    'unpaid',
]);
// Shared types for billing information
export const BillingInfo = v.object({
    customerId: v.nullable(v.string()),
    subscription: v.optional(v.nullable(v.object({
        tier: PricingTier,
        status: SubscriptionStatus,
        trialEnd: v.nullable(coercedDate()),
        periodEnd: v.nullable(coercedDate()),
        isCanceled: v.boolean(),
    })), null),
    nextPayment: v.optional(v.nullable(v.object({
        amount: v.number(), // in cents
        paymentMethodLast4: v.string(),
        date: coercedDate(),
    })), null),
});
export const billingApi = api({
    // Get current billing information
    'GET /api/billing/info': {
        input: v.object({}),
        output: BillingInfo,
        requiresSession: true,
    },
    // Create checkout session for subscription
    'POST /api/billing/checkout': {
        input: v.object({
            tier: PricingTier,
            period: v.optional(v.picklist(['monthly', 'yearly']), 'yearly'),
            successUrl: v.pipe(v.string(), v.url()),
            cancelUrl: v.pipe(v.string(), v.url()),
        }),
        output: v.object({
            url: v.pipe(v.string(), v.url()),
        }),
        requiresSession: true,
    },
    // Create portal session for subscription management
    'POST /api/billing/portal': {
        input: v.object({
            returnUrl: v.pipe(v.string(), v.url()),
        }),
        output: v.object({
            url: v.pipe(v.string(), v.url()),
        }),
        requiresSession: true,
    },
});
//# sourceMappingURL=billing.js.map